module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-21.3f859298.png";